import React from 'react';
import BrokerageManagement from '../components/plaid/brokerageManagement/index';

const PlaidIntegrationPage: React.FC = () => {
  return (
    <div>
      <BrokerageManagement />
    </div>
  );
};

export default PlaidIntegrationPage;